<script lang="ts">
    import { onMount } from "svelte";
    import Container from "../../components/Container.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import Hero from "../../components/Hero.svelte";

    import type { News } from "../../components/NewsCard.svelte";
    import Headline from "../../components/Headline.svelte";
    import Subline from "../../components/Subline.svelte";
    import Gap from "../../components/Gap.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Btn from "../../components/Btn.svelte";
    import Image from "../../components/Image.svelte";
    import type { ProjectPreview } from "../../components/ProjectPreviews.svelte";
    import ProjectPreviews from "../../components/ProjectPreviews.svelte";
    import { t } from "../../helpers/translation";

    type EventDate = ProjectPreview & {
        id: number;
        title: string;
        url: string;
        startdate: string;
        enddate: string;
        image: string;
        bodyhtml: string;
        iframehtml: string;
        hidden: boolean;
        date: string;
    };

    const loadData = async (): Promise<EventDate[]> => {
        const data: EventDate[] = await fetch("/api/termine")
            .then((data) => data.json())
            .then((data) => {
                data.forEach((event) => {
                    if (event.startdate && event.enddate)
                        event.date =
                            new Date(event.startdate).toLocaleDateString() +
                            " - " +
                            new Date(event.enddate).toLocaleDateString();
                    else if (event.startdate)
                        event.date = new Date(
                            event.startdate,
                        ).toLocaleDateString();
                    else if (event.enddate)
                        event.date = new Date(
                            event.enddate,
                        ).toLocaleDateString();
                    else event.date = "";
                });
                console.warn(data);
                return data;
            });

        return data ? Promise.resolve<EventDate[]>(data) : Promise.reject(null);
    };
</script>

<!-- <LightTheme /> -->
<Hero headline={$t("page.events.hero.headline")} small />

<Container>
    <Headline>
        {@html $t("page.events.headline")}
    </Headline>
    <Subline>
        {@html $t("page.events.subline")}
    </Subline>

    <ProjectPreviews
        data_callback={loadData}
        url_base="aktuelles/termine"
        button_text={$t("page.events.btn.event")}
        headline=""
    />
</Container>

<style lang="scss">
    @import "../../vars";

    .event {
        // display: grid;
        // gap: 1em;
        // grid-template-columns: 3fr 1fr;
    }
    .events {
        :global(img) {
            max-height: 50vh !important;
            object-fit: contain !important;
            object-position: top left !important;
        }
    }
</style>
